import { createExternalStore } from "@nova/toolkit-pure-hooks"

export type TimelineDensitySeries = {
    binMs: number
    originMs: number
    counts: Uint16Array
}

const densityStore = createExternalStore<TimelineDensitySeries>()

export const publishTimelineDensity = (id: string, series: TimelineDensitySeries | null): void => {
    if (series) densityStore.set(id, series)
    else densityStore.remove(id)
}

export const useTimelineDensity = (id: string): TimelineDensitySeries | null =>
    densityStore.useItem(id) ?? null

export const bucketizeDensity = (
    series: TimelineDensitySeries,
    startMs: number,
    bucketMs: number,
    bucketCount: number
): Uint32Array => {
    const out = new Uint32Array(bucketCount)
    const { originMs, binMs, counts } = series
    for (let i = 0; i < counts.length; i++) {
        const c = counts[i]
        if (c === 0) continue
        const b = Math.floor((originMs + i * binMs + binMs / 2 - startMs) / bucketMs)
        if (b >= 0 && b < bucketCount) out[b] += c
    }
    return out
}
